import MenuItemMui from '@mui/material/MenuItem';
import { withStyles } from '@mui/styles';

const MenuItem = withStyles({
  root: {
    minHeight: 32,
    color: '#0072A2',
    whiteSpace: 'pre-wrap !important',
  },
  selected: {
    backgroundColor: '#EAF0F6 !important',
  }
})(MenuItemMui);

export default MenuItem;